// This has been turned into a module because I need it in two different
// locations. Once to supply default fees to redux, and once to supply to
// the actual FastTitlefee dropdown menu.

// function LoadFast() {
//     var ft = thisGetField("FastTitle")
//     ft.clearItems();
//     ft.setItems([
//       ["Title issued by DMV -print&mail", 2.50],
//       ["Fast Title Fee", 10.00],
//       ["Electronic Title", 0.00]
//     ]);
// }

// function LoadVesselFast() {
//     var ft = thisGetField("FastTitle")
//     ft.clearItems();
//     ft.setItems([
//       ["Title issued by DMV", 2.50],
//       ["Vessel Fast Title Fee", 5.00],
//       ["Electronic Title", 0.00]
//     ]);
// }

// function LoadOHFast() {
//     var ft = thisGetField("FastTitle")
//     ft.clearItems();
//     ft.setItems([
//       ["Title issued by DMV", 2.50],
//       ["Off-Highway Fast Title Fee", 7.00],
//       ["Electronic Title", 0.00]
//     ]);
// }

// function DisableLoadFast() {
//     var ft = thisGetField("FastTitle");
//     ft.clearItems();
//     ft.setItems(["No Fast Title fee", 0.00]);
//     ft.prop('readonly', true);
// }
import getPipeValue from './getPipeValue';

function getFastTitleDropdownOptions(options) {
  const { selectedVehicleValue } = options;
  const { floridaTitle, mcoTitle, osTitle } = options.selectedTitleVariables;
  const t2 = Number(options.selectedTitleVariables.t2);
  const t4 = Number(options.selectedTitleVariables.t4);
  let r16 = 0;
  if (selectedVehicleValue) {
    r16 = Number(getPipeValue(selectedVehicleValue, 'r16'));
  }

  // Just for debugging. Remove after fully tested.
  // console.log('FastTitle, getOptions', { r16, t2, t4, floridaTitle, mcoTitle, osTitle });

  const loadFast = [
    ['Title issued by DMV -print&mail', 2.50],
    ['Electronic Title', 0.00],
    ['Fast Title Fee', 10.00],
  ];

  const loadVesselFast = [
    ['Title issued by DMV', 2.50],
    ['Electronic Title', 0.00],
    ['Vessel Fast Title Fee', 5.00],
  ];

  const loadOHFast = [
    ['Title issued by DMV', 2.50],
    ['Electronic Title', 0.00],
    ['Off-Highway Fast Title Fee', 7.00],
  ];

  const disableLoadFast = [
    ['No Fast Title fee', 0.00],
  ];

  let dropdown = disableLoadFast;

  // Note: we have to sortof 'cascade' down the list of
  // dropdowns because of how John formatted his PDF Code.

  // These are the options are they appear in the PDF
  // when you choose an option from `Florida Title`
  if (floridaTitle) {
    if (r16 === t2 || r16 === 0 || t2 === 8) {
      if (t2 === 5) {
        dropdown = loadVesselFast;
      } else {
        dropdown = loadFast;
      }

      if (t2 === 7) {
        dropdown = loadOHFast;
      }

      if (t4 === 2) {
        dropdown = disableLoadFast;
      }
    }
  }

  // These are the options are they appear in the PDF
  // when you choose an option from `MCO Manufacturer`
  if (mcoTitle) {
    if (r16 === t2 || r16 === 0) {
      dropdown = loadFast;

      if (t2 === 5) {
        dropdown = loadVesselFast;
      } else {
        dropdown = loadFast;
      }

      if (t2 === 7) {
        dropdown = loadOHFast;
      }
    }
  }

  // These are the options are they appear in the PDF
  // when you choose an option from `Out of State Title`
  if (osTitle) {
    if (r16 === t2 || r16 === 0) {
      dropdown = loadFast;

      if (t2 === 5) {
        dropdown = loadVesselFast;
      } else {
        dropdown = loadFast;
      }
      if (t2 === 7) {
        dropdown = loadOHFast;
      }
      if (t4 === 2) {
        dropdown = disableLoadFast;
      }
    }
  }

  return dropdown;
}

export default getFastTitleDropdownOptions;



// WEBPACK FOOTER //
// ./src/modules/getFastTitleDropdownOptions.js